import React from 'react';
import classNames from 'classnames';
import { LockOutlinedIcon, PlayCircleIcon } from 'icons';
import { useRouter } from 'next/router';

import { useAppDispatch, useAppSelector } from 'store';

import { openAuthModal } from 'modules/auth';
import { formatDuration, globalConst } from 'modules/global';
import { setPaymentModal } from 'modules/lesson-detail';

import { Visible } from 'components';

interface IProps {
  available?: boolean;
  title?: string;
  progress?: number;
  slug?: string;
  duration?: number;
}

export const Lesson: React.FC<IProps> = ({ available = false, progress = 0, title, slug, duration }) => {
  const { query, push } = useRouter();
  const dispatch = useAppDispatch();
  const isAuth = useAppSelector(({ user }) => user?.phone);

  const onEnterLesson = () => {
    if (!isAuth) {
      return dispatch(openAuthModal());
    }

    if (!available) {
      return dispatch(setPaymentModal(true));
    }

    return push(`${globalConst.pageNames.COURSES}/${query?.course}/${slug}`);
  };

  return (
    <div
      onClick={onEnterLesson}
      className={classNames(
        'duration-400 flex cursor-pointer items-center justify-between rounded-lg bg-white p-3.5 transition-all ease-in-out hover:scale-[1.02] hover:shadow',
        {
          'opacity-100': available,
          'opacity-60': !available
        }
      )}
    >
      <div className="flex items-center gap-3 text-sm font-medium">
        <Visible
          if={available}
          else={
            <>
              <LockOutlinedIcon />
              <p>{title}</p>
            </>
          }
        >
          <PlayCircleIcon />
          <p>{title}</p>
        </Visible>
      </div>
      <div className="flex items-center gap-3">
        <Visible if={available} else={<p className="text-sm">{formatDuration(duration)}</p>}>
          <div className="flex items-center gap-3">
            <div className="hidden items-center gap-2 md:flex">
              <div className="flex-1 rounded-full border border-gray-200 p-0.5">
                <div className="h-3 w-20 rounded-full bg-gray-100">
                  <div
                    className="h-3 rounded-full bg-green-500"
                    style={{
                      width: `${progress}%`
                    }}
                  />
                </div>
              </div>
              <div className="text-sm font-medium">{progress}%</div>
            </div>
            <p className="text-sm">{formatDuration(duration)}</p>
          </div>
        </Visible>
      </div>
    </div>
  );
};
